import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { IGetRefinerResponse } from '../models/IGetRefinerResponse';

import { IGetUserResponse } from '../models/IGetUserResponse';
import { ILocation } from '../models/ILocation';
import { IRefinerItems } from '../models/IRefinerItems';
import { ISelectedRefinerItem } from '../models/ISelectedRefinerItem';
import { ISite } from '../models/ISite';
import Constants from './Constants';

export const authTokenAtom = atomWithStorage('authToken', '');
export const locationsAtom = atom<Array<ILocation>>([]);
export const selectedLocationIdAtom = atom<number>(Constants.DEFAULT_ID);
export const sitesAtom = atom<Array<ISite>>([]);
export const selectedSitesAtom = atom<Array<string>>([]);
export const currentKQLQueryAtom = atom<string>('');
export const currentSortQueryAtom = atom<string>('');
export const hitHighlightingEnabledAtom = atom<boolean>(false);
export const useRefinerOverridesAtom = atom<boolean>(false);
export const refinersExpandedAtom = atom<boolean>(true);
export const refinersAtom = atom<Array<IGetRefinerResponse>>([]);
export const refinerItemsAtom = atom<IRefinerItems>({});
export const selectedRefinerItemsAtom = atom<Array<ISelectedRefinerItem>>([]);
export const searchKeywordAtom = atom('');
export const pageSizeAtom = atom(10);
export const isInitializingAtom = atom(false);
export const startRowAtom = atom(0);
export const currentPageIndexAtom = atom(1);
export const currentUserAtom = atom<IGetUserResponse | null>(null);
